import { IPurchaseRequisitionTask, PurchaseRequisitionTask } from '../../../types/PurchaseRequisitionTask';
import { IRecord } from '@lib/util';
import { IPerson, PersonExtended } from '@lib/user';
import { DemandDataService } from '../../../../demand/demand-data.service';
import { CommentDataService } from '@lib/comment';
import { ItemClassificationDataService } from '@lib/classification';
import { FileDataService } from '@lib/file';
import { I18nService } from '@lib/i18n';

export interface IPurchaseRequisitionChooseSingleApproverTask extends IPurchaseRequisitionTask {
    defaultApprover: IRecord<string>;
    possibleApprovers: IPerson[];
    approverRequired: boolean;
}

export class PurchaseRequisitionChooseSingleApproverTask extends PurchaseRequisitionTask {
    defaultApprover: PersonExtended | undefined;
    possibleApprovers: PersonExtended[];
    approverRequired: boolean;

    constructor(
        dto: IPurchaseRequisitionChooseSingleApproverTask,
        demandDataService: DemandDataService,
        commentDataService: CommentDataService,
        itemClassificationDataService: ItemClassificationDataService,
        fileDataService: FileDataService,
        i18n: I18nService
    ) {
        super(dto, demandDataService, commentDataService, itemClassificationDataService, fileDataService, i18n);
        this.possibleApprovers = dto.possibleApprovers.map((person) => new PersonExtended(person));
        this.defaultApprover = this.possibleApprovers.find((person) => person.equals(dto.defaultApprover?.value));
        this.approverRequired = dto.approverRequired;
    }
}
